import * as types from './constants'

const initialState = {
	questions: [],
	question: null,
	test: 'test',
	folderTitle: '',
	thumbValue: null,
	thumbFile: null,
	folderSelectedQuestions: [],
	test: 'test',
	allFolders: [],
	openMoveQuestion: '',
	openedFolder: '',
	editingFolder: null,
	renameFolder: false,
	toggleEditFolder: false,
	addFolderToggle: false,
}

// export default (state = initialState, action) => {
// 	switch (action.type) {
// 		case types.SET_QUESTION:
// 			return {
// 				...state,
// 				question: action.question,
// 			}
// 		case types.SET_QUESTIONS:
// 			return {
// 				...state,
// 				questions: action.payload,
// 			}

// 		default:
// 			return state
// 	}
// }

const questionBankReducer = (state = initialState, action) => {
	switch (action.type) {
		case types.SET_QUESTION:
			return {
				...state,
				question: action.question,
			}
		case types.SET_QUESTIONS:
			return {
				...state,
				questions: action.payload,
			}
		case types.SET_FOLDER_TITLE:
			return {
				...state,
				folderTitle: action.payload,
			}
		case types.SET_FOLDER_THUMBNAIL:
			return {
				...state,
				folderThumbnail: action.payload,
			}
		case types.SET_FOLDER_SELECTED_QUESTIONS:
			return {
				...state,
				folderSelectedQuestions: action.payload,
			}
		case types.FOLDER_THUMBNAIL:
			return {
				...state,
				thumbValue: action.payload,
			}
		case types.FOLDER_THUMBNAIL_FILE:
			return {
				...state,
				thumbFile: action.payload,
			}
		case types.SET_ALL_FOLDERS_QUESTIONS:
			return {
				...state,
				allFolders: action.payload,
			}
		case types.SET_OPEN_MOVE_QUESTION:
			return {
				...state,
				openMoveQuestion: action.payload,
			}
		case types.SET_OPENED_FOLDER:
			return {
				...state,
				openedFolder: action.payload,
			}
		case types.SET_EDIT_FOLDER:
			return {
				...state,
				editingFolder: action.payload,
			}

		case types.SET_RENAME_FOLDER:
			return {
				...state,
				renameFolder: !state.renameFolder,
			}
		case types.SET_TOGGLE_EDIT_FOLDER:
			return {
				...state,
				toggleEditFolder: action.payload,
			}
		case types.SET_ADD_FOLDER_TOGGLE:
			return {
				...state,
				addFolderToggle: !state.addFolderToggle,
			}

		default:
			return state
	}
}

export default questionBankReducer
